import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Store, FileText, TicketCheck, TrendingUp, AlertCircle } from 'lucide-react';

export default function AdminDashboard() {
  const { t } = useTranslation();
  const { data, isLoading } = useQuery({ queryKey: ['/admin/stats'] });
  const stats = data?.data;

  const cards = [
    { title: t('adm_dashboard.totalMerchants'), value: stats?.merchants.total ?? 0, icon: Store, color: 'text-primary' },
    { title: t('adm_dashboard.activeMerchants'), value: stats?.merchants.active ?? 0, icon: Store, color: 'text-green-600' },
    { title: t('adm_dashboard.blocked'), value: stats?.merchants.blocked ?? 0, icon: AlertCircle, color: 'text-destructive' },
    { title: t('adm_dashboard.pending'), value: stats?.merchants.pending ?? 0, icon: Store, color: 'text-yellow-600' },
    { title: t('adm_dashboard.totalSales'), value: stats?.sales.total_count ?? 0, icon: TrendingUp, color: 'text-primary' },
    { title: t('adm_dashboard.murabahaCases'), value: stats?.murabaha.total ?? 0, icon: FileText, color: 'text-primary' },
    { title: t('adm_dashboard.pendingMurabaha'), value: stats?.murabaha.pending ?? 0, icon: FileText, color: 'text-yellow-600' },
    { title: t('adm_dashboard.tickets'), value: stats?.tickets.total ?? 0, icon: TicketCheck, color: 'text-primary' },
  ];

  return (
    <div className="p-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground">{t('adm_dashboard.title')}</h1>
        <p className="text-muted-foreground text-sm">{t('adm_dashboard.subtitle')}</p>
      </div>

      {isLoading ? (
        <div className="text-muted-foreground">{t('adm_common.loading')}</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map(card => (
            <Card key={card.title}>
              <CardHeader className="flex flex-row items-center justify-between pb-2">
                <CardTitle className="text-sm font-medium text-muted-foreground">{card.title}</CardTitle>
                <card.icon size={18} className={card.color} />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold">{card.value}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
